import React from "react";
import { PageHeader, Marker } from "./../Components";
import get_branches from "actions/get_branches";
import get_organization from "actions/get_organization";
import get_atms from "actions/get_atms";
import MapPrevImg from "./../media/map_pev.jpg";
import GoogleMap from "google-map-react";
import { connect } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import { baseUrl } from "env";
import { Col } from "Components";
import { bindActionCreators } from "redux";
class Branches extends React.PureComponent {
  state = {
    currentTab: {
      title: ""
    },
    branches: []
  };
  async componentDidMount() {
    await this.props.get_organization();
    await this.props.get_branches();
    await this.props.get_atms();
    this.setState({
      currentTab: this.props.data[0]
    });
  }
  navigate = item => {
    this.setState({
      currentTab: item
    });
  };
  render = () => (
    <div>
      <PageHeader
        headerClass={"contact-us"}
        pageName="Şubelerimiz ve Bankamatikler"
      />
      <div className="container about_us_wrapper mt80 mb80">
        <Col l={8} m={12}>
          <p className="title">{this.state.currentTab.title}</p>
          {this.state.currentTab.atms ? (
            <div className="row">
              {this.props.atms.map((branch, key) => (
                <div key={key} className="branch_item">
                  <div className="map_prev">
                    {branch.lat && branch.lng ? (
                      // <ReactGoogleMapImage
                      //   config={{
                      //     center: "32 wulemotu ajoke street akoka",
                      //     size: "400x266",
                      //     zoom: "15",
                      //     key: "AIzaSyAKQZFjE_faAmglNdD8LwWhkGJGM48jOkk",
                      //     maptype: "roadmap"
                      //   }}
                      //   wrapperStyle={{ width: "100%" }}
                      //   style={{
                      //     width: "100px",
                      //     height: "auto",
                      //     border: "1px solid #ccc"
                      //   }}
                      // />
                      <GoogleMap
                        style={{
                          height: 120,
                          maxWidth: 180,
                          width: 180,
                          position: "relative",
                          borderTop: "5px solid #ec4f2e"
                        }}
                        apiKey={"AIzaSyAKQZFjE_faAmglNdD8LwWhkGJGM48jOkk"}
                        center={[
                          parseFloat(branch.lat),
                          parseFloat(branch.lng)
                        ]}
                        zoom={15}
                      >
                        <Marker
                          lat={parseFloat(branch.lat)}
                          lng={parseFloat(branch.lng)}
                        />
                      </GoogleMap>
                    ) : (
                      <img alt="" src={MapPrevImg} />
                    )}
                  </div>
                  <div className="branch_content">
                    <p className="branch_title">{branch.title}</p>
                    <p className="branch_info_item">{branch.address}</p>
                    <p className="branch_info_item">{branch.phone}</p>
                    <p className="branch_info_item">{branch.fax}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          {this.state.currentTab.branchs ? (
            <div className="row">
              {this.props.branches.map((branch, key) => (
                <div key={key} className="branch_item">
                  <div className="map_prev">
                    {branch.lat && branch.lng ? (
                      <GoogleMap
                        style={{
                          height: 120,
                          maxWidth: 180,
                          width: 180,
                          position: "relative",
                          borderTop: "5px solid #ec4f2e"
                        }}
                        apiKey={"AIzaSyAKQZFjE_faAmglNdD8LwWhkGJGM48jOkk"}
                        center={[
                          parseFloat(branch.lat),
                          parseFloat(branch.lng)
                        ]}
                        zoom={15}
                      >
                        <Marker
                          lat={parseFloat(branch.lat)}
                          lng={parseFloat(branch.lng)}
                        />
                      </GoogleMap>
                    ) : (
                      <img alt="" src={MapPrevImg} />
                    )}
                  </div>
                  <div className="branch_content">
                    <p className="branch_title">{branch.title}</p>
                    <p className="branch_info_item">{branch.address}</p>
                    <p className="branch_info_item">{branch.phone}</p>
                    <p className="branch_info_item">{branch.fax}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          {this.state.currentTab.content_html
            ? ReactHtmlParser(this.state.currentTab.content_html)
            : null}
          {this.state.currentTab.media_id ? (
            <img
              alt=""
              src={`${baseUrl}/api/media/media/${
                this.state.currentTab.media_id
              }`}
            />
          ) : null}
        </Col>
        <Col l={4} m={12} className="navigation_tab">
          <ul>
            {this.props.data.map((item, key) => (
              <li
                className={
                  this.state.currentTab.title === item.title ? "active" : ""
                }
                onClick={() => this.navigate(item)}
                key={key}
              >
                {item.title}
              </li>
            ))}
          </ul>
        </Col>
      </div>
      {/* <GoogleMap
        style={{
          height: 350,
          width: "100%",
          position: "relative",
          borderTop: "5px solid #ec4f2e"
        }}
        apiKey={"AIzaSyAKQZFjE_faAmglNdD8LwWhkGJGM48jOkk"}
        center={[35.208227, 33.3644321]}
        zoom={15}
      >
        <Marker lat={35.208227} lng={33.3644321} />
      </GoogleMap> */}
    </div>
  );
}
const mapStateToProps = state => ({
  branches: state.branches ? state.branches.data : [],
  atms: state.atms ? state.atms.data : [],
  data: state.organization ? state.organization.data : []
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_branches,
      get_atms,
      get_organization
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Branches);
